export const colors = {
    BLUE: "#008EC8",
    GREY:"#606C73",
    ORANGE:"#DB6727",
    LIGHT_ORANGE: "#E5AD4D",
    YELLOW: "#FFE000",
    
    // Modern color palette
    PRIMARY: '#5B4FFF',
    PRIMARY_DARK: '#4339F2',
    PRIMARY_LIGHT: '#7B73FF',
    
    // Accent colors
    SUCCESS: '#22C55E',
    WARNING: '#F59E0B',
    ERROR: '#EF4444',
    INFO: '#3B82F6',
    
    // Neutral colors
    DARK_BG: '#0F0F23',
    DARK_SURFACE: '#1A1A2E',
    DARK_CARD: '#25253D',
    
    // Text colors
    TEXT_PRIMARY: '#FFFFFF',
    TEXT_SECONDARY: '#A0A0B8',
    TEXT_MUTED: '#6B6B80',
    
    // Border colors
    BORDER_LIGHT: 'rgba(255, 255, 255, 0.1)',
    BORDER_DEFAULT: 'rgba(255, 255, 255, 0.15)',
    
    // Gradient colors
    GRADIENT_1: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    GRADIENT_2: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
    GRADIENT_3: 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)',
    GRADIENT_4: 'linear-gradient(135deg, #fa709a 0%, #fee140 100%)',
};
